<template>
  <div class="bg-white rounded-xl shadow-sm p-3 sm:p-4 md:p-5 transition-all duration-300 hover:shadow-md">
    <div class="flex flex-col gap-1 mb-4">
      <h3 class="text-xl font-bold text-gray-800">Evolución de Puntos últimas 4 Semanas</h3>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4">
      <div class="rounded-lg border border-neutral-200 bg-white p-3 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-sm">
        <p class="text-xs font-semibold text-neutral-500">Total Puntos</p>
        <p class="text-2xl font-bold text-neutral-800">{{ totalPoints }}</p>
      </div>
      <div class="rounded-lg border border-neutral-200 bg-white p-3 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-sm">
        <p class="text-xs font-semibold text-neutral-500">Semanas Activas</p>
        <p class="text-2xl font-bold text-neutral-800">{{ activeWeeks }}/4</p>
      </div>
      <div class="rounded-lg border border-neutral-200 bg-white p-3 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-sm">
        <p class="text-xs font-semibold text-neutral-500">Crecimiento WoW</p>
        <p class="text-2xl font-bold text-emerald-600">{{ wowGrowth }}</p>
      </div>
    </div>

    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <div
          class="relative mb-4 bg-gray-50 rounded-lg p-4"
          :class="chartHeightClass"
        >
          <b-skeleton animation="wave" height="100%" width="100%"></b-skeleton>
        </div>
      </template>
      <div class="relative mb-4" :class="chartHeightClass">
        <line-chart
          v-if="chartDataLoaded"
          :chart-data="chartData"
          :options="chartOptions"
          style="height: 100%; width: 100%;"
        ></line-chart>
      </div>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import LineChart from "../../statistics/LineChart.js";

export default {
  name: "PointsEvolutionGraph",

  props: {
    compact: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    LineChart,
  },

  data() {
    return {
      loading: true,
      chartDataLoaded: false,
      chartData: {
        labels: [],
        datasets: [
          {
                label: 'Puntos',
                data: [],
                backgroundColor: 'rgba(148, 163, 184, 0.15)',
                borderColor: 'rgba(148, 163, 184, 0.8)',
                borderWidth: 2,
                pointBackgroundColor: [],
                pointBorderColor: '#FFFFFF',
                pointBorderWidth: 2,
                pointRadius: 4,
                tension: 0.25,
          }
              ,
              {
                label: 'Semana Activa',
                data: [],
                backgroundColor: 'rgba(34, 197, 94, 0.1)',
                borderColor: 'rgba(34, 197, 94, 1)',
                borderWidth: 3,
                pointBackgroundColor: 'rgba(34, 197, 94, 1)',
                pointBorderColor: '#FFFFFF',
                pointBorderWidth: 2,
                pointRadius: 6,
                tension: 0.25,
              },
        ]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
            animation: {
              duration: 800,
              easing: "easeOutQuart",
            },
        legend: {
          display: false
        },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: function (value) {
                return value; // Muestra el número de puntos sin símbolo
              }
            },
            gridLines: {
              color: 'rgba(0, 0, 0, 0.05)'
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return 'Puntos: ' + tooltipItem.yLabel;
            }
          }
        }
      },
    }
  },

  computed: {
    chartHeightClass() {
      return this.compact ? "h-52 md:h-60" : "h-64 md:h-80";
    },
      totalPoints() {
        return this.chartData.datasets[0].data.reduce((sum, value) => sum + (value || 0), 0);
      },
      activeWeeks() {
        return this.chartData.datasets[0].data.filter((value) => value > 0).length;
      },
      wowGrowth() {
        const data = this.chartData.datasets[0].data;
        const last = data[data.length - 1] || 0;
        const prev = data[data.length - 2] || 0;
        if (last === 0) return "0%";
        if (prev === 0) return "+600%";
        return `+${Math.round(((last - prev) / prev) * 100)}%`;
      },
  },

  created() {
    this.loadChartData();
  },
  activated() {
    this.loadChartData();
  },

  methods: {
    applyPointsToChart(labels, data) {
      this.chartData.labels = labels;
      this.chartData.datasets[0].data = data;
      this.chartData.datasets[0].pointBackgroundColor = data.map((value) =>
        value > 0 ? "rgba(34, 197, 94, 1)" : "rgba(148, 163, 184, 1)"
      );
      this.chartData.datasets[1].data = data.map((value, index) =>
        index === data.length - 1 && value > 0 ? value : null
      );
      this.chartDataLoaded = true;
    },
    async loadChartData() {
      this.chartDataLoaded = false;
      this.loading = true;
      try {
        const data = await this.$store.dispatch("dashboardCache/fetchDashboardDataIfNeeded");
        const response = data?.pointsEvolution;
        if (!response || typeof response !== "object") {
          this.loading = false;
          return;
        }
        const labels = response.labels || [];
        const pointsData = Array.isArray(response.data) ? response.data : [];
        this.applyPointsToChart(labels, pointsData);
      } catch (error) {
        console.error("Error al cargar datos del gráfico de puntos:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
